import React from 'react';
import RfqRequestPreviewPresenter from './RfqRequestPreviewPresenter';

const RfqRequestPreviewContainer: React.FC = () => {
  return <RfqRequestPreviewPresenter />;
};

export default RfqRequestPreviewContainer;
